module.exports = __webpack_public_path__ + "img/brillante_7.5eef2981.svg";